"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hierarchy = void 0;
const index_1 = require("../state/containers/index");
const graphsource_1 = require("graphsource");
const react_1 = __importStar(require("react"));
const typestyle_1 = require("typestyle");
const theme_1 = require("./theme");
const index_2 = require("./TreeToNodes/index");
const Main = typestyle_1.style({
    width: '100%',
    position: 'relative',
});
exports.Hierarchy = () => {
    const { tree, libraryTree } = index_1.useTreesState();
    const [hierarchy, setHierarchy] = react_1.useState();
    const diagramRef = react_1.useRef(null);
    react_1.useLayoutEffect(() => {
        if (diagramRef.current) {
            setDOMElement(diagramRef.current);
        }
    }, []);
    react_1.useEffect(() => {
        if (hierarchy && tree && libraryTree) {
            const tr = index_2.TreeToNodes.resolveTree({
                nodes: [...tree.nodes, ...libraryTree.nodes],
            });
            hierarchy.setNodes(tr.nodes);
        }
    }, [tree, hierarchy, libraryTree]);
    const setDOMElement = (element) => {
        setHierarchy(new graphsource_1.Diagram(element, {
            theme: theme_1.theme,
        }));
    };
    return react_1.default.createElement("div", { className: Main, ref: diagramRef });
};
